import React, { useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { prism } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { FiCopy, FiPlay, FiCode, FiMaximize2 } from 'react-icons/fi';
import FullScreenEditor from './FullScreenEditor';

const CodeExample = ({ example }) => {
  const [copied, setCopied] = useState(false);
  const [showOutput, setShowOutput] = useState(false);
  const [isEditorOpen, setIsEditorOpen] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(example.code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <div className="code-example">
        <div className="code-header">
          <div className="code-title">
            <FiCode /> {example.title || 'Code Example'}
          </div>
          <div className="code-actions">
            <button 
              className="code-btn primary"
              onClick={() => setIsEditorOpen(true)}
              title="Open in fullscreen editor"
            >
              <FiMaximize2 /> Practice Code
            </button>
            {example.output && (
              <button 
                className="code-btn"
                onClick={() => setShowOutput(!showOutput)}
              >
                <FiPlay /> {showOutput ? 'Hide Output' : 'Run Code'}
              </button>
            )}
            <button 
              className="code-btn secondary"
              onClick={handleCopy}
            >
              <FiCopy /> {copied ? 'Copied!' : 'Copy'}
            </button>
          </div>
        </div>
      <div className="code-body">
        <SyntaxHighlighter 
          language="csharp" 
          style={prism}
          customStyle={{
            margin: 0,
            padding: '24px',
            background: '#f8f9fa',
            border: '1px solid #e1e4e8',
            borderRadius: '8px',
            fontSize: '16px',
            lineHeight: '1.8'
          }}
          showLineNumbers={true}
          wrapLines={true}
        >
          {example.code}
        </SyntaxHighlighter>
        
        {showOutput && example.output && (
          <div className="code-output">
            <div className="output-label">Output:</div>
            <div className="output-content">{example.output}</div>
          </div>
        )}
      </div>
      
      {example.explanation && (
        <div style={{ 
          padding: '20px 24px', 
          background: '#fff3cd',
          color: '#856404',
          borderTop: '2px solid #ffc107',
          fontSize: '16px',
          lineHeight: '1.8'
        }}>
          <strong style={{ fontSize: '17px' }}>💡 Explanation:</strong> {example.explanation}
        </div>
      )}
      </div>

      {/* Fullscreen Editor Modal */}
      <FullScreenEditor
        isOpen={isEditorOpen}
        onClose={() => setIsEditorOpen(false)}
        initialCode={example.code}
        title={example.title || 'Code Practice'}
        language="csharp"
      />
    </>
  );
};

export default CodeExample;

